/*
 * PRISM core — shared utilities for PRISM premium components.
 * Vanilla JS, no dependencies. Integrates with Dawn's pubsub (constants.js / pubsub.js).
 * Loaded once; each PRISM component registers its own custom element in its own asset file.
 */
window.PRISM = window.PRISM || {};

(function (PRISM) {
  'use strict';

  // Respect the merchant animation toggle + the user's OS preference.
  PRISM.prefersReducedMotion = function () {
    if (document.documentElement.classList.contains('prism-no-motion')) return true;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  // Fetch a rendered section via the Section Rendering API (server-rendered, localized, a11y-safe).
  // url: a storefront URL; sectionId: the section id to request.
  PRISM.fetchSection = function (url, sectionId) {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) {
      if (!r.ok) throw new Error('PRISM: section fetch failed (' + r.status + ')');
      return r.text();
    });
  };

  // Parse an HTML string into a DocumentFragment.
  PRISM.parseHTML = function (html) {
    return new DOMParser().parseFromString(html, 'text/html');
  };

  // Accessible focus trap for modals/drawers. Returns a release() function.
  PRISM.trapFocus = function (container, focusFirst) {
    const selector =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]),' +
      ' textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), summary, [contenteditable]';
    const focusables = Array.prototype.slice.call(container.querySelectorAll(selector));
    const first = focusFirst || focusables[0];
    const last = focusables[focusables.length - 1];
    const previouslyFocused = document.activeElement;

    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      if (focusables.length === 0) return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKeydown);
    if (first) first.focus();

    return function release() {
      container.removeEventListener('keydown', onKeydown);
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
    };
  };

  // Debounce helper.
  PRISM.debounce = function (fn, wait) {
    let t;
    return function () {
      const ctx = this;
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait || 200);
    };
  };

  // Format a price (cents) using the shop's money format injected on <body data-money-format>.
  PRISM.formatMoney = function (cents) {
    const fmt = (document.body && document.body.getAttribute('data-prism-money-format')) || '${{amount}}';
    const value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
  };
})(window.PRISM);
